import store from "../store";

// directives
export default {
    install: (app, options) => {
        app.directive("permission", {
            mounted: function (el, binding, vnode, old) {
                store.dispatch("security/auth");
                store
                    .dispatch("security/can", { action: binding.value })
                    .then((has) => {
                        if (!has) {
                            vnode.el.parentElement.removeChild(vnode.el);
                        }
                    });
            },
        });
        app.directive("menu-visible", {
            mounted: function (el, binding, vnode, old) {
                let data = binding.value;

                if (data.item == null) {
                    vnode.el.parentElement.removeChild(vnode.el);
                } else {
                    if (data.item.visibilidad != null && data.item.users_visibilidad != null && data.item.visibilidad == false) {
                        if (!data.item.users_visibilidad.some(uVisibilidad => uVisibilidad.nfc_usuarios_id == data.auth?.id)) {
                            vnode.el.parentElement.removeChild(vnode.el);
                        }
                    }
                }
            },
        });
        app.directive("not-permission", {
            mounted: function (el, binding, vnode, old) {
                store.dispatch("security/auth");
                store
                    .dispatch("security/can", { action: binding.value })
                    .then((has) => {
                        if (has) {
                            vnode.el.parentElement.removeChild(vnode.el);
                        }
                    });
            },
        });
    },
};
